const isDesignSystemColorToken = (value: string) =>
    value.startsWith("components-") || value.startsWith("text-");

const isDesignSystemFontSizeToken = (value: string) =>
    value.startsWith("mobile-") || value.startsWith("desktop-");

const isDesignSystemFontFamilyToken = (value: string) =>
    [
        "button-text",
        "heading",
        "label",
        "navigation",
        "paragraph-base",
        "paragraph-large",
        "tag-text",
    ].includes(value);

const isDesignSystemFontWeightToken = (value: string) =>
    value.startsWith("heading-") ||
    value.startsWith("interactive-") ||
    value.startsWith("label-") ||
    value.startsWith("paragraph-") ||
    value === "tag";

export const designSystemTwMergeConfig = {
    twMergeConfig: {
        extend: {
            classGroups: {
                "font-family": [{ font: [isDesignSystemFontFamilyToken] }],
                "font-size": [{ text: [isDesignSystemFontSizeToken] }],
                "font-weight": [{ "font-weight": [isDesignSystemFontWeightToken] }],
                "text-case": [{ text: ["case-button", "case-heading"] }],
                "text-color": [{ text: [isDesignSystemColorToken] }],
            },
            theme: {
                color: [isDesignSystemColorToken],
                text: [isDesignSystemFontSizeToken],
            },
        },
    },
};
